$(document).ready(function(){
    //alert("loaded");
    $(document).on('change', '#checkTermCart', function() {
    if ($(this).is(':checked')) {
        $('.cart__ctas').removeClass('cart__ctas_disabled');
    } else {
        $('.cart__ctas').addClass('cart__ctas_disabled');
    }
    });
})